
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/egypt/forms/download-prospectus",
      function () {
        return require("private-next-pages/egypt/forms/download-prospectus.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/egypt/forms/download-prospectus"])
      });
    }
  